import { Component, Input, OnInit } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';
import { Utils } from '../../../../utils/utils';

@Component({
    selector: 'app-language-flags',
    templateUrl: './language-flags.component.html',
    styleUrls: ['./language-flags.component.css'],
    standalone: false
})
export class LanguageFlagsComponent extends TableElementComponent {
  @Input() languages?: string[];

  protected Utils = Utils;

  override ngOnInit() {
    super.ngOnInit();
    this.languages = this.data['languagesSpoken'];
  }
}